/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ProcedureStatusItemList } from '../../models/procedure-status-item-list';

export interface ProcedureControllerGetNextProcedureStatuses$Params {
  id: number;
}

export function procedureControllerGetNextProcedureStatuses(http: HttpClient, rootUrl: string, params: ProcedureControllerGetNextProcedureStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProcedureStatusItemList;
}>> {
  const rb = new RequestBuilder(rootUrl, procedureControllerGetNextProcedureStatuses.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ProcedureStatusItemList;
      }>;
    })
  );
}

procedureControllerGetNextProcedureStatuses.PATH = '/procedure/{id}/next-procedure-status';
